import * as React from "react"

const NARROW_MOBILE_BREAKPOINT = 640

export function useIsMobilePortrait() {
  const [isMobilePortrait, setIsMobilePortrait] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const checkMobilePortrait = () => {
      const isNarrow = window.innerWidth < NARROW_MOBILE_BREAKPOINT
      const isPortrait = window.matchMedia("(orientation: portrait)").matches
      setIsMobilePortrait(isNarrow && isPortrait)
    }

    const widthMql = window.matchMedia(`(max-width: ${NARROW_MOBILE_BREAKPOINT - 1}px)`)
    const orientationMql = window.matchMedia("(orientation: portrait)")

    widthMql.addEventListener("change", checkMobilePortrait)
    orientationMql.addEventListener("change", checkMobilePortrait)
    
    checkMobilePortrait()

    return () => {
      widthMql.removeEventListener("change", checkMobilePortrait)
      orientationMql.removeEventListener("change", checkMobilePortrait)
    }
  }, [])

  return !!isMobilePortrait
}
